import * as basicScroll from 'basicscroll'

const parallax = () => {

  const mobile = window.matchMedia('(max-width: 769px)');
  const elms = document.querySelectorAll('.c-parallax-section');

  if(elms) {

    elms.forEach(el => {
      const instance = basicScroll.create({
        elem: el,
        direct: true,
        from: mobile.matches ? 'top-middle' : 'bottom-middle',
        to: mobile.matches ? 'bottom-middle' : 'top-middle',
        props: {
          '--scroll-title': {
            from: mobile.matches ? '8%' : '30%',
            to: mobile.matches ? '-20%' : '-30%',
          },
          '--scroll-text': {
            from: mobile.matches ? '10%' : '80%',
            to: mobile.matches ? '-10%' : '-30%',
          },
          '--scroll-image': {
            from: mobile.matches ? '10%' : '-6%',
            to: mobile.matches ? '-25%' : '-18%',
          }
        }
      })

      instance.start();

    });
  }
}

parallax();
